import { createContext, useContext } from 'react';

/** What a game board can reach on the surrounding board page: tool mode and slots. */
export interface BoardChrome {
  tool: string;
  /** Large-board mode (bigger cells, horizontal scroll). */
  large: boolean;
  /** Pan mode (only meaningful with `large`): pointer input pans instead of drawing. */
  panMode: boolean;
  setTool: (tool: string) => void;
  /** Element in the toolbar for game tool-mode toggles (render into it with <ToolbarSlot>). */
  toolbarSlot: HTMLElement | null;
  /** Element below the board for a keypad or word slots (render into it with <KeypadSlot>). */
  keypadSlot: HTMLElement | null;
  /** Element in the disclosure card where the board's keyboard help is rendered (null: render inline). */
  helpSlot?: HTMLElement | null;
  /** Element in the disclosure card for a game's guide or legend (render into it with a portal). */
  extrasSlot?: HTMLElement | null;
  /** The puzzle is solved: the board plays its one-off hop wave. */
  solved?: boolean;
  /** The board reports how long its solve hop lasts (ms; 0 under reduced motion) so the sheet can follow it. */
  reportHopMs?: (ms: number) => void;
}

export const BoardChromeContext = createContext<BoardChrome | null>(null);

export function useBoardChrome(): BoardChrome {
  const c = useContext(BoardChromeContext);
  if (!c) throw new Error('useBoardChrome must be used inside a board page');
  return c;
}
